"use strict";
/*
* Created on 11.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Amount of product designed for ordering, rounding and minimum quantities are respected.
 * @author ZSr
 */


var SupplierOrderSuggested =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(SupplierOrderSuggested, _StateDomainObject_1$);

  /**
   * @param id internal id
   * @param externalId
   * @param siteId identification of sites
   * @param supplierId
   * @param dateOfOrder
   * @param promotionId
   * @param productId
   * @param amount
   * @param stateFlags
   */
  function SupplierOrderSuggested(id, externalId, siteId, supplierId, dateOfOrder, promotionId, productId, amount, stateFlags) {
    var _this;

    _classCallCheck(this, SupplierOrderSuggested);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierOrderSuggested).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.siteId = siteId;
    _this.supplierId = supplierId;
    _this.dateOfOrder = dateOfOrder;
    _this.promotionId = promotionId;
    _this.productId = productId;
    _this.amount = amount;
    _this.stateFlags = stateFlags;
    return _this;
  }

  return SupplierOrderSuggested;
}(StateDomainObject_1.StateDomainObject);

exports.SupplierOrderSuggested = SupplierOrderSuggested;

SupplierOrderSuggested.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SupplierOrderSuggested.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    siteId: builder.str('siteId'),
    supplierId: builder.str('supplierId'),
    dateOfOrder: builder.date('dateOfOrder', DateParser_1.DateParser.ISO_PATTERN),
    promotionId: builder.opt(builder.str('promotionId')),
    productId: builder.str('productId'),
    amount: builder.bigNum('amount'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();